import React from 'react'

const ScheduleNotCompleted = ({ fill, height = 35, viewBox = '-2 -2 40 40', width = 35 }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={width}
    height={height} 
    viewBox={viewBox}
  >
    <g id="filtro-nao-realizadas-off" clip-path="url(#clip-path)">
      <g id="Grupo_562" data-name="Grupo 562" transform="translate(-302.844 -33.378)">
        <path 
          id="Caminho_2261" 
          data-name="Caminho 2261" 
          d="M320.994,33.378a18.151,18.151,0,1,0,18.152,18.151,18.028,18.028,0,0,0-18.152-18.151h0ZM321,67.348h0a15.816,15.816,0,1,1,11.188-4.634A15.839,15.839,0,0,1,321,67.348Z" 
          fill={fill}
        />
      </g>
      <path 
        id="Caminho_2262" 
        data-name="Caminho 2262" 
        d="M320.994,53.436h0l3.812,3.81,1.907-1.907-3.812-3.81,3.813-3.813-1.907-1.906-3.813,3.811-3.812-3.812-1.907,1.906,3.813,3.813-3.813,3.812,1.907,1.907,3.81-3.81Z" 
        transform="translate(-302.844 -33.378)" 
        fill={fill}
      />
    </g>
  </svg>
)

export default ScheduleNotCompleted

